<template>
  <div v-if="items && items.length" class="page-tabs">
    <span v-if="moduleLabel" class="page-tabs-module">{{ moduleLabel }}</span>
    <nav class="page-tabs-nav">
      <button
        v-for="(item, index) in items"
        :key="index"
        type="button"
        class="page-tab"
        :class="{ active: isActive(item), disabled: item.disabled }"
        :disabled="item.disabled"
        :title="item.tooltip || ''"
        @click="go(item)"
      >
        {{ item.label }}
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  name: "ThePageTabs",
  computed: {
    items() {
      return this.$store.state.pageNavItems || [];
    },
    moduleLabel() {
      return this.$store.state.navItemType || "";
    },
    activeLabel() {
      return this.$store.state.navActiveItem || "";
    },
  },
  methods: {
    isActive(item) {
      // When the page declares the active item, trust it exclusively (avoids
      // false matches when several unimplemented tabs share one placeholder route).
      if (this.activeLabel) return item.label === this.activeLabel;
      // Otherwise fall back to matching the current route.
      return !!item.route && this.$route.path.toLowerCase() === item.route.toLowerCase();
    },
    go(item) {
      if (item.disabled || !item.route) return;
      if (this.$route.path.toLowerCase() === item.route.toLowerCase()) return;
      this.$router.push(item.route).catch(() => {});
    },
  },
};
</script>

<style scoped>
.page-tabs {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
}
.page-tabs::-webkit-scrollbar { height: 4px; }
.page-tabs::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

.page-tabs-module {
  flex: 0 0 auto;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  padding-right: 0.5rem;
  border-right: 1px solid #e2e8f0;
}

.page-tabs-nav {
  display: flex;
  align-items: stretch;
  gap: 0.25rem;
}

.page-tab {
  flex: 0 0 auto;
  position: relative;
  border: none;
  background: transparent;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.85rem 0.85rem;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}
.page-tab:hover:not(.disabled):not(.active) {
  color: #1e3a5f;
  background: #f8fafc;
}
.page-tab.active {
  color: #1e3a5f;
  border-bottom-color: #10b981;
}
.page-tab.disabled {
  color: #cbd5e1;
  cursor: not-allowed;
}
.page-tab:focus-visible {
  outline: 2px solid #10b981;
  outline-offset: -2px;
  border-radius: 4px;
}

/* Dark mode */
.c-dark-theme .page-tabs { background: #1e2430; border-bottom-color: #2f3a4d; }
.c-dark-theme .page-tab { color: #adb5bd; }
.c-dark-theme .page-tab.active { color: #fff; }
.c-dark-theme .page-tabs-module { color: #6b7280; border-right-color: #2f3a4d; }

@media (max-width: 575.98px) {
  .page-tabs { padding: 0 0.75rem; }
  .page-tabs-module { display: none; }
  .page-tab { padding: 0.75rem 0.65rem; font-size: 0.78rem; }
}

@media (prefers-reduced-motion: reduce) {
  .page-tab { transition: none; }
}
</style>
